import Breadcrumbs from "components/Common/BreadCrumbs";
import React, { useRef, useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import {
  Badge,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Row,
  Table,
} from "reactstrap";
import { showAlert, ActionButton } from "components/Common/commonFunctions";
import {
  getJobByID,
  getJobTimeLineByID,
  getTechnicalReportByID,
} from "actions/job";
import NotificationAlert from "react-notification-alert";
import { useDispatch, useSelector } from "react-redux";
import { cancelJobByJobId } from "actions/job";
import { updateJobStatus } from "actions/job";
import { downloadJobReportByJobId } from "actions/job";
import { getJobMediaByJobID } from "actions/job";
import { downloadJobMedia } from "actions/job";
import { formatSAR } from "components/Common/commonFunctions";
import { SMALL_CASE_WORK_ORDER } from "components/Common/constants";
import { urlDecodedId } from "components/Common/encodeDecodeFunction";
import { WORK_ORDER } from "components/Common/constants";
import { toTitleCase } from "components/Common/commonFunctions";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import { REACT_APP_GOOGLE_MAPS_API_KEY } from "components/Common/constants";
import { getServiceList } from "actions/job";
import { getEquipmentManual } from "actions/job";
import { downloadEquipmentInvoice } from "actions/job";
import { downloadQuotationHistory } from "actions/job";
import CustomModal from "./CustomModal";
import { downloadProductManual } from "actions/job";
import { getQuotationDetails } from "actions/job";
import { updateStatusQuotation } from "actions/job";
import { JOB_STATUS_OPTIONS } from "components/Common/constants";
import { getJobStatusStyle } from "components/Common/constants";

const initialFields = {
  customer: {
    value: "",
    label: "",
    phone: "",
    email: "",
    address: "",
  },
  customerLocation: {
    value: "",
    outletName: "",
    address: "",
    contactPersonName: "",
    contactPersonPhone: "",
    contactEmail: "",
    alternateContactPersonName: "",
    alternateContactPersonPhone: "",
    alternateContactEmail: "",
    regionID: "",
    regionName: "",
  },
  customerEquipment: {
    value: "",
    assetTag: "",
    invoicePath: "",
    seller: "",
    serialNo: "",
    status: "",
    underWarranty: "",
    equipmentImage: ""
  },

  jobTypeID: { value: "", label: "" },
  technician: { value: "", label: "" },

  manufacturer: { value: "", label: "" },
  product: { value: "", label: "", modelNo: "" },

  scheduledFrom: "",
  scheduledTo: "",

  priority: "",
  jobStatus: "",

  clientNote: "",
  adminNote: { value: "", error: "" },
  partsNote: "",
  warrantyNote: "",

  partRequestedReceivedOn: "",
  partRequestedEtaDate: "",
  partRequestedStatus: "",
  purchaseDate: "",

  jobReferenceNo: { value: "", error: "" },
  jobSalesOrderNo: "",
  partsPurchaseOrderNo: "",
  paymentTerm: { ID: 0, term: "" },
};

const techinicalReportInitialState = {
  ID: { value: "", error: "" },
  jobID: "",
  technicianID: { value: "", label: "", error: "" },
  serialNo: { value: "", error: "" },
  causeOfFailure: { value: "", error: "" },
  additionalInfo: { value: "", error: "" },
  otherFinding: { value: "", error: "" },
  media: [],
};


function JobDetails() {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: REACT_APP_GOOGLE_MAPS_API_KEY,
  });
  const defaultCenter = { lat: 24.7136, lng: 46.6753 };
  const location = useLocation();

  const data = location.state || {};

  const { id: encodedId } = useParams();
  const decodedId = urlDecodedId(encodedId);

  const dispatch = useDispatch();

  const quotationDetails = useSelector((state) => state.quotation.quotationList);
  const serviveHistoryData = useSelector((state) => state.customer?.serviceHistory || {});

  const notificationAlertRef = useRef(null);
  const rejectReasonRef = useRef("");
  const cancelReasonRef = useRef("");

  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedPDF, setSelectedPDF] = useState(null);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [jobFormData, setJobFormData] = useState(initialFields);
  const [timeline, setTimeline] = useState([]);
  const [techRepoFormData, setTechRepoFormData] = useState(
    techinicalReportInitialState,
  );

  const [showAlternative, setShowAlternative] = useState({
    loader: false, //loader for job details api
    techRepoLoader: false,
    timeLineLoader: false,
    error: "", //job details error
    techRepoError: "",
    timeLineError: "",
    feedbackError: "",
  });

  const [quotationId, setQuotationId] = useState(null);
  const [quotationListState, setQuotationListState] = useState({
    loader: false,
    error: "",
    noRecords: false,
  });
  const [quotationSummary, setQuotationSummary] = useState(null);
  const [equipmentData, setequipmentData] = useState({ loading: false, data: null, error: "" });

  const [isDownloading, setIsDownloading] = useState(false);
  const [isAPiProcessing, setIsAPiProcessing] = useState(false);
  const [jobMediaData, setjobMediaData] = useState([]);
  const [historyState, setHistoryState] = useState({
    loader: false,
    error: "",
    noRecords: false,
  });
  const [showDetails, setShowDetails] = useState(false);
  const [markerPosition, setMarkerPosition] = useState(null);
  const [map, setMap] = useState(null);
  const [mapError, setMapError] = useState("");

  useEffect(() => {
    if (decodedId) {
      getJobDetails(decodedId);
      timeLineDetails(decodedId);
      technicalReportDetails(decodedId);
      getJobMedia();
      fetchQuotationList();
      getEquimentManuals();
    }

  }, [decodedId]);

  useEffect(() => {
    if (decodedId && jobFormData?.customerEquipment?.value)
      fetchServiceHistory()
  }, [decodedId, jobFormData?.customerEquipment?.value])

  useEffect(() => {
    if (!quotationListState.loader) return;
    if (!quotationDetails) return;

    const res = quotationDetails;

    // Handle no records
    if (res.code === 404) {
      setQuotationListState({
        loader: false,
        error: "",
        noRecords: true,
      });
      return;
    }

    // Handle other errors
    if (res.code !== 200) {
      setQuotationListState({
        loader: false,
        error: res?.message || "Failed to fetch quotation details",
        noRecords: false,
      });
      return;
    }

    const quotation = res?.data || {};

    if (quotation.ID) {
      setQuotationId(quotation.ID);
    }

    const quotData = [
      ...(quotation?.quotationItems?.spareParts || []),
      ...(quotation?.quotationItems?.services || []),
    ];

    setQuotationSummary({
      ...quotation,
      quotData,
    });

    setQuotationListState({
      loader: false,
      error: "",
      noRecords: false,
    });
  }, [quotationDetails]);

  useEffect(() => {
    if (!historyState.loader) return;
    if (!serviveHistoryData) return;

    const res = serviveHistoryData;

    // Handle no records
    if (res.code === 404) {
      setHistoryState({
        loader: false,
        error: "",
        noRecords: true,
      });
      return;
    }

    // Handle other errors
    if (res.code !== 200) {
      setHistoryState({
        loader: false,
        error: res?.message || "Failed to fetch service history",
        noRecords: false,
      });
      return;
    }

    setHistoryState({
      loader: false,
      error: "",
      noRecords: false,
    });
  }, [serviveHistoryData]);


  useEffect(() => {
    setQuotationId(null);
  }, [decodedId]);

  useEffect(() => {
    if (!isLoaded || !data?.address) return;

    if (!window.google?.maps) {
      setMapError("Google Maps failed to load.");
      return;
    }

    const geocoder = new window.google.maps.Geocoder();

    geocoder.geocode({ address: data.address }, (results, status) => {
      if (
        status === window.google.maps.GeocoderStatus.OK &&
        results?.length
      ) {
        const location = results[0].geometry.location;

        setMarkerPosition({
          lat: location.lat(),
          lng: location.lng(),
        });

        setMapError("");
      } else {
        setMarkerPosition(null);
        setMapError("Unable to locate the provided address.");
      }
    });
  }, [isLoaded, data?.address]);

  const convertTimeline = (backendList) => {
    return backendList.map((item) => {

      return {
        date: item.date ? item.date : "-",
        event: toTitleCase(item.custDescription),
      };
    });
  };

  const technicalReportDetails = async (id) => {
    try {
      setShowAlternative((prev) => ({
        ...prev,
        techRepoLoader: true,
        techRepoError: false,
      }));
      const res = await getTechnicalReportByID(id);
      if (res.code === 200) {
        const technicalReportRes = res?.data;
        setTechRepoFormData({
          ID: { value: technicalReportRes?.ID || "", error: "" },
          jobID: { value: technicalReportRes?.jobID || "", error: "" },
          technicianID: {
            value: technicalReportRes?.technicianID?.ID || "",
            label: technicalReportRes?.technicianID?.name || "",
            error: "",
          },
          serialNo: { value: technicalReportRes?.serialNo || "", error: "" },
          causeOfFailure: {
            value: technicalReportRes?.causeOfFailure || "",
            error: "",
          },
          additionalInfo: {
            value: technicalReportRes?.additionalInfo || "",
            error: "",
          },
          otherFinding: {
            value: technicalReportRes?.otherFinding || "",
            error: "",
          },
          media: technicalReportRes?.tecnicalReportMedia || [],
        });

        setShowAlternative((prev) => ({
          ...prev,
          techRepoLoader: false,
          techRepoError: false,
        }));
      } else {
        const message = Array.isArray(res?.message)
          ? res?.message[0]?.Msg
          : res?.message || "Failed to load spare part details!";
        setShowAlternative((prev) => ({
          ...prev,
          techRepoLoader: false,
          techRepoError: message,
        }));
      }
    } catch (error) {
      setShowAlternative((prev) => ({
        ...prev,
        techRepoLoader: false,
        techRepoError: error || "Failed to load timeline!",
      }));
    }
  };


  const timeLineDetails = async (id) => {
    try {
      setShowAlternative((prev) => ({
        ...prev,
        timeLineLoader: true,
        timeLineError: false,
      }));
      const res = await getJobTimeLineByID(id);

      if (res.code === 200) {
        const formattedList = convertTimeline(res.data.jobTimeLine || []);
        setTimeline(formattedList);
        setShowAlternative((prev) => ({
          ...prev,
          timeLineLoader: false,
          timeLineError: false,
        }));
      } else {
        const message = Array.isArray(res?.message)
          ? res?.message[0]?.Msg
          : res?.message || "Failed to load timeline!";
        setShowAlternative((prev) => ({
          ...prev,
          timeLineLoader: false,
          timeLineError: message,
        }));
      }
    } catch (error) {
      setShowAlternative((prev) => ({
        ...prev,
        timeLineLoader: false,
        timeLineError: error || "Failed to load timeline!",
      }));
    }
  };

  const getJobDetails = async (jobId) => {
    try {
      setShowAlternative((prev) => ({ ...prev, loader: true, error: false }));
      const res = await getJobByID(jobId);

      if (res.code === 200) {
        const jobDetailsRes = res?.data;

        setJobFormData({
          // basic ids / labels
          customer: {
            value: jobDetailsRes.customer?.ID || "",
            label: jobDetailsRes.customer?.name || "",
            phone: jobDetailsRes.customer?.phone || "",
            email: jobDetailsRes.customer?.email || "",
            address: jobDetailsRes.customer?.address || "",
          },
          customerLocation: {
            value: jobDetailsRes.customerLocation?.ID || "",
            label: jobDetailsRes.customerLocation?.regionResponce?.name || "",
            address: jobDetailsRes.customerLocation?.address || "",
            outletName: jobDetailsRes.customerLocation?.outletName || "",
            contactPersonName:
              jobDetailsRes.customerLocation?.contactPersonName || "",
            contactPersonPhone:
              jobDetailsRes.customerLocation?.contactPersonPhone || "",
            contactEmail: jobDetailsRes.customerLocation?.contactEmail || "",
            alternateContactPersonName:
              jobDetailsRes.customerLocation?.alternateContactPersonName || "",
            alternateContactPersonPhone:
              jobDetailsRes.customerLocation?.alternateContactPersonPhone || "",
            alternateContactEmail:
              jobDetailsRes.customerLocation?.alternateContactEmail || "",
            regionID: jobDetailsRes.customerLocation?.regionResponce?.ID || "",
            regionName: jobDetailsRes.customerLocation?.regionResponce?.name || "",
          },
          customerEquipment: {
            value: jobDetailsRes.customerEquipment?.ID || "",
            serialNo: jobDetailsRes.customerEquipment?.serialNo || "",
            assetTag: jobDetailsRes.customerEquipment?.assetTag || "",
            invoicePath: jobDetailsRes.customerEquipment?.invoicePath || "",
            seller: jobDetailsRes.customerEquipment?.seller || "",
            status: jobDetailsRes.customerEquipment?.status || "",
            underWarranty: jobDetailsRes.customerEquipment?.underWarranty || "",
            equipmentImage: jobDetailsRes.product?.imagePath || "",
          },

          // job type / technician
          jobTypeID: {
            value: jobDetailsRes.jobTypeID?.ID || "",
            label: jobDetailsRes.jobTypeID?.name || "",
          },
          technician: {
            value: jobDetailsRes.technician?.ID || "",
            label: jobDetailsRes.technician?.name || "",
          },

          // manufacturer / product
          manufacturer: {
            value: jobDetailsRes.manufacturer?.ID || "",
            label: jobDetailsRes.manufacturer?.name || "",
          },
          product: {
            value: jobDetailsRes.product?.ID || "",
            label: jobDetailsRes.product?.name || "",
            modelNo: jobDetailsRes.product?.modelNo || "",
          },

          // schedule & reasons
          scheduledFrom: jobDetailsRes.scheduledFrom || "",
          scheduledTo: jobDetailsRes.scheduledTo || "",
          rescheduleReason: jobDetailsRes.rescheduleReason || "",
          cancelledReason: jobDetailsRes.cancelledReason || "",
          underWarranty: jobDetailsRes.underWarranty || "",

          // identifiers / reference numbers
          jobReferenceNo: { value: jobDetailsRes.jobReferenceNo || "" },
          error: "",
          jobSalesOrderNo: jobDetailsRes.jobSalesOrderNo || "",
          partsPurchaseOrderNo: jobDetailsRes.partsPurchaseOrderNo || "",

          // notes
          clientNote: jobDetailsRes.clientNote || "",
          adminNote: { value: jobDetailsRes.adminNote || "" },
          error: "",
          partsNote: jobDetailsRes.partsNote || "",
          warrantyNote: jobDetailsRes.warrantyNote || "",

          //purchaseDate
          purchaseDate: jobDetailsRes.purchaseDate || "",

          // part request fields
          partRequestedReceivedOn: jobDetailsRes.partRequestedReceivedOn || "",
          partRequestedEtaDate: jobDetailsRes.partRequestedEtaDate || "",
          partRequestedStatus: jobDetailsRes.partRequestedStatus || "",

          // priority / status / metadata
          priority: jobDetailsRes.priority || "",
          jobStatus: jobDetailsRes.jobStatus || "",
          createdByID: jobDetailsRes.createdByID || "",
          completedOn: jobDetailsRes.completedOn || "",
          jobSchedules: jobDetailsRes.jobSchedules || [],
          paymentTerm: {
            ID: jobDetailsRes?.paymentTerm?.ID,
            term: jobDetailsRes?.paymentTerm?.term,
          },
          internalTrackingFlag: jobDetailsRes.internalTrackingFlag || "NO"
        });

        if (jobDetailsRes?.customerLocation?.mapDetails?.coordinates) {
          setMarkerPosition(jobDetailsRes?.customerLocation?.mapDetails.coordinates);
        }

        setShowAlternative((prev) => ({
          ...prev,
          loader: false,
          error: false,
        }));
      } else {
        const message = Array.isArray(res?.message)
          ? res?.message[0]?.Msg
          : res?.message || "Failed to load spare part details!";
        setShowAlternative((prev) => ({
          ...prev,
          loader: false,
          error: message,
        }));
      }
    } catch (error) {
      setShowAlternative((prev) => ({
        ...prev,
        loader: false,
        error: error || "Failed to load spare part details!",
      }));
    }
  };

  const getJobMedia = async () => {
    try {
      const res = await getJobMediaByJobID(decodedId);
      if (res?.code === 200) {
        setjobMediaData(res?.data);
      }
    } catch (error) {
    }
  };


  const notify = (type, message) => {
    let finalMessage = message;

    if (Array.isArray(message)) {
      finalMessage = message[0]?.Msg || "Something went wrong";
    } else if (typeof message === "object") {
      finalMessage = message?.Msg || "Something went wrong";
    }
    const options = {
      place: "tr",
      message: <div>{finalMessage}</div>,
      type,
      icon: "tim-icons icon-bell-55",
      autoDismiss: 5,
    };
    notificationAlertRef?.current?.notificationAlert(options);
  };

  const downloadJobReport = async () => {
    setIsDownloading(true);
    try {
      const res = await downloadJobReportByJobId(decodedId);
      if (res.status === 200 && res.data) {
        const fileName =
          res.headers["content-disposition"]?.match(/filename="(.+?)"/)?.[1] ||
          `${SMALL_CASE_WORK_ORDER}_${decodedId}.pdf`;

        const blob = new Blob([res.data], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(url);
      } else if (res.code === 404) {
        notify(
          "danger",
          `The ${SMALL_CASE_WORK_ORDER} report not found. Please try again.`,
        );
      } else {
        notify(
          "danger",
          res?.message ||
          `Failed to download ${SMALL_CASE_WORK_ORDER} report. Please try again.`,
        );
      }
    } catch (error) {
      notify(
        "danger",
        error?.message ||
        `Failed to download ${SMALL_CASE_WORK_ORDER} report. Please try again.`,
      );
    }
    setIsDownloading(false);
  };

  const downloadEquipmentManual = async (productDocumentID) => {
    setIsDownloading(true);
    try {
      const res = await downloadProductManual(productDocumentID, "document");
      if (res.status === 200 && res.data) {
        const fileName =
          res.headers["content-disposition"]?.match(/filename="(.+?)"/)?.[1];
        const url = URL.createObjectURL(res.data);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(url);
      } else if (res.code === 404) {
        notify("danger", res?.message || "Manual not found.");
      } else {
        notify(
          "danger",
          res?.message || "Failed to download manual. Please try again.",
        );
      }
    } catch (error) {
      notify(
        "danger",
        error?.message || "Failed to download manual. Please try again.",
      );
    }
    setIsDownloading(false);
  };

  const downloadInvoice = async (productDocumentID) => {
    setIsDownloading(true);
    try {
      const res = await downloadEquipmentInvoice(productDocumentID);
      if (res.status === 200 && res.data) {
        const fileName =
          res.headers["content-disposition"]?.match(/filename="(.+?)"/)?.[1];
        const url = URL.createObjectURL(res.data);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(url);
      } else if (res.code === 404) {
        notify("danger", res?.message || "Invoice not found.");
      } else {
        notify(
          "danger",
          res?.message || "Failed to download invoice. Please try again.",
        );
      }
    } catch (error) {
      notify(
        "danger",
        error?.message || "Failed to download invoice. Please try again.",
      );
    }
    setIsDownloading(false);
  };

  // download files based on type
  const handleFileDownload = (type, id) => {
    switch (type) {
      case "job_report":
        downloadJobReport();
        return;

      case "equipment_manual":
        downloadEquipmentManual(id);
        break;

      case "quotation":
        return downloadQuotationHistoryFile(id);

      case "invoice":
        downloadInvoice(id);
        break;

      case "viewQuot":
        return viewQuotationFile(id);

      default:
        return;
    }
  };

  const downloadQuotationHistoryFile = async (item) => {
    setIsDownloading(true);
    try {
      const res = await downloadQuotationHistory(item?.quotationID || item);

      if (res.status === 200 && res.data) {
        const version = item?.version ?? quotationDetails?.data?.version ?? "0";
        const baseName =
          version !== 0
            ? `quotation-${decodedId}-${version}`
            : `quotation-${decodedId}`;
        const fileName =
          res.headers["content-disposition"]?.match(/filename="(.+?)"/)?.[1] ||
          `${baseName}.pdf`;
        const blob = new Blob([res.data], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(url);
        showAlert({
          type: "success",
          title: "Download Successful",
          message: <span>Quotation downloaded successfully.</span>,
          showCancel: false,
          confirmText: "OK",
          confirmStyle: "success",
        });
      } else {
        showAlert({
          type: "warning",
          title: "Download Failed",
          message: "no file found.",
          showCancel: false,
          confirmText: "OK",
        });
      }
    } catch (err) {
      showAlert({
        type: "warning",
        title: "Download Failed",
        message: "no file found",
        showCancel: false,
        confirmText: "OK",
      });
    }
    setIsDownloading(false);
  };

  const viewQuotationFile = async (item) => {
    setIsAPiProcessing(true);
    setSelectedPDF(null);

    try {
      const res = await downloadQuotationHistory(item?.quotationID || item);

      if (res.status === 200 && res.data) {
        const blob = new Blob([res.data], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);

        setSelectedPDF(url);
      } else {
        showAlert({
          type: "warning",
          title: "Unable to Open",
          message: "No quotation found.",
          showCancel: false,
          confirmText: "OK",
        });
      }
    } catch (err) {
      showAlert({
        type: "warning",
        title: "Unable to Open",
        message: "No quotation found.",
        showCancel: false,
        confirmText: "OK",
      });
    }

    setIsAPiProcessing(false);
  }

  const completeOrReworkJob = async (status) => {
    setIsAPiProcessing(true);
    try {
      let payload = {
        JobStatus: status,
      };
      const res = await updateJobStatus(decodedId, payload);
      if (res?.code !== 200) {
        notify(
          "danger",
          res?.message || `Failed to update ${SMALL_CASE_WORK_ORDER} status`,
        );
        return;
      }

      notify(
        "success",
        res?.message || `${WORK_ORDER} status updated successfully.`,
      );

      await fetchQuotationList();
      await getJobDetails(decodedId);
      await timeLineDetails(decodedId);
    } catch (error) {
      notify("danger", "Something went wrong");
    } finally {
      setIsAPiProcessing(false);
    }
  };

  // show confirmation alerts based on action type
  const handleConfirmationAlerts = (type) => {
    switch (type) {
      case "cancel_job":
        return showAlert({
          title: `Are you sure you want to cancel this ${SMALL_CASE_WORK_ORDER}?`,
          type: "warning",
          message:
            "This action cannot be undone. Please provide a reason for cancellation:",
          confirmStyle: "danger",
          cancelStyle: "secondary",
          confirmText: "Yes, Cancel",
          cancelText: "No",
          onConfirm: () => handleCancelJob(),
          onCancel: () => { },
          children: (
            <FormGroup className="mt-2 d-flex flex-column align-items-start">
              <Input
                name="reason"
                type="textarea"
                placeholder="Enter reason *"
                onChange={(e) => {
                  cancelReasonRef.current = e.target.value;
                }}
              />
            </FormGroup>
          ),
        });

      case "reject_quotation":
        return showAlert({
          title: "Are you sure you want to reject this quotation?",
          type: "warning",
          message:
            "This action cannot be undone. Please provide a reason for rejection.",
          confirmStyle: "danger",
          cancelStyle: "secondary",
          confirmText: "Yes, Reject",
          cancelText: "No",
          // onConfirm: () => {},
          onConfirm: () => handleRejctQuotation(),
          onCancel: () => { },
          children: (
            <FormGroup className="mt-2 d-flex flex-column align-items-start">
              <Input
                name="rejectReason"
                type="textarea"
                placeholder="Enter reason *"
                // value={inputs.rejectReason}
                // onChange={(e) => {
                //   e.stopPropagation();
                //   handleCommonInputs("rejectReason", e.target.value);
                // }}
                onChange={(e) => {
                  rejectReasonRef.current = e.target.value;
                }}
              />
            </FormGroup>
          ),
        });

      case "review_work_done":
        return showAlert({
          title: "Confirmation of Work Done",
          type: "warning",
          message: "Please confirm whether you approve the completed work or reopen it for additional work.",
          confirmStyle: "default",
          cancelStyle: "secondary",
          confirmText: "Approve",
          cancelText: "Reopen",
          onConfirm: () => completeOrReworkJob("COMPLETED"),
          onCancel: () => completeOrReworkJob("REWORK_REQUIRED"),
        });

      case "accept_quotation":
        return showAlert({
          title: "Are you sure you want to accept this quotation?",
          type: "warning",
          message: "This action cannot be undone. Please confirm to continue.",
          confirmStyle: "default",
          cancelStyle: "secondary",
          confirmText: "Yes, Accept",
          cancelText: "No",
          onConfirm: () => { handleApprovedQuotation() },
          onCancel: () => { },
        });

      default:
        return;
    }
  };

  const fetchQuotationList = async () => {
    setQuotationListState({
      loader: true,
      error: "",
      noRecords: false,
    });

    await getQuotationDetails(dispatch, decodedId);
  };

  const getEquimentManuals = async () => {
    try {
      const res = await getEquipmentManual(decodedId);
      if (res?.code === 200) {
        setequipmentData({ loading: false, data: res?.data, error: "" });
      } else {
        setequipmentData({ loading: false, data: null, error: res?.message || "Failed to get manuals" });
      }
    } catch (error) {
      setequipmentData({ loading: false, data: null, error: error?.message || "Failed to get manuals" });
    }
  };

  const fetchServiceHistory = async () => {
    setHistoryState({
      loader: true,
      error: "",
      noRecords: false,
    });

    await getServiceList(dispatch, jobFormData?.customerEquipment?.value);
  };



  const handleRejctQuotation = async () => {
    const reason = rejectReasonRef.current;

    if (!quotationId) {
      notify("warning", "Quotation is not avaliable yet.");
      return;
    }

    if (!reason) {
      notify("danger", "Please enter the reason for rejecting the quotation");
      return;
    }

    const payload = {
      quotationID: quotationId,
      jobID: decodedId,
      status: "QUOTATION_REJECTED",
      rejectionReason: reason,
    };

    setIsAPiProcessing(true);
    try {
      const res = await updateStatusQuotation(payload);

      if (res?.code !== 200) {
        notify("danger", res?.message || "Failed to update quotation status");
        return;
      }

      notify("success", res?.message || "Quotation Rejected Successfully.");

      setQuotationSummary(null);
      setQuotationId(null);
      await getJobDetails(decodedId);
      await timeLineDetails(decodedId);
    } catch (error) {
      notify("danger", "Something went wrong");
    } finally {
      setIsAPiProcessing(false);
    }
  };

  const handleCancelJob = async () => {
    const reason = cancelReasonRef.current;
    setIsAPiProcessing(true);
    try {
      const payLoad = {
        JobStatus: "CANCELLED",
        CancelledReason: reason,
      };

      const res = await cancelJobByJobId(decodedId, payLoad);

      if (res?.code !== 200) {
        notify(
          "danger",
          res?.message || `Failed to update ${SMALL_CASE_WORK_ORDER} status`,
        );
        return;
      }
      notify(
        "success",
        res?.message || `${WORK_ORDER} Cancelled Successfully.`,
      );
      await getJobDetails(decodedId);
      await timeLineDetails(decodedId);
    } catch (error) {
      notify("danger", "Something went wrong");
    } finally {
      setIsAPiProcessing(false);
    }
  };

  const handleApprovedQuotation = async () => {
    if (!quotationId) {
      notify("warning", "Quotation is not avaliable yet.");
      return;
    }
    const payload = {
      quotationID: quotationId,
      jobID: decodedId,
      status: "QUOTATION_APPROVED",
    };
    setIsAPiProcessing(true);
    try {
      const res = await updateStatusQuotation(payload);

      if (res?.code !== 200) {
        notify("danger", res?.message || "Failed to update quotation status");
        return;
      }

      notify("success", res?.message || "Quotation Approved Successfully.");

      await fetchQuotationList();
      await getJobDetails(decodedId);
      await timeLineDetails(decodedId);
    } catch (error) {
      notify("danger", "Something went wrong");
    } finally {
      setIsAPiProcessing(false);
    }
  };

  // used to render job details screens actions based on job status
  const renderJobInfoActionBtns = () => {
    const status = jobFormData.jobStatus;

    switch (status) {
      case "JOB_ALLOCATED":
        return (
          <div className="job-action-buttons">
            <ActionButton
              icon="fa-download"
              label={`${WORK_ORDER} Report`}
              onClick={() => handleFileDownload("job_report")}
            />
            <ActionButton
              color="secondary"
              icon="fa-close"
              label={`Cancel ${WORK_ORDER}`}
              onClick={() => handleConfirmationAlerts("cancel_job")}
            />
          </div>
        );

      case "REQUEST_APPROVAL":
        return (
          <div className="job-action-buttons">
            <ActionButton
              icon="fa-download"
              label={`${WORK_ORDER} Report`}
              onClick={() => handleFileDownload("job_report")}
            />
            <ActionButton
              color="secondary"
              icon="fa-close"
              label={`Cancel ${WORK_ORDER}`}
              onClick={() => handleConfirmationAlerts("cancel_job")}
            />
          </div>
        );

      case "QUOTATION_IN_PROGRESS":
        return (
          <div className="job-action-buttons">
            <ActionButton
              icon="fa-download"
              label={`${WORK_ORDER} Report`}
              onClick={() => handleFileDownload("job_report")}
            />
            <ActionButton
              color="secondary"
              icon="fa-close"
              label={`Cancel ${WORK_ORDER}`}
              onClick={() => handleConfirmationAlerts("cancel_job")}
            />
          </div>
        );

      case "QUOTATION_ACCEPTED":
        return (
          <div className="job-action-buttons">
            <ActionButton
              icon="fa-download"
              label={`${WORK_ORDER} Report`}
              onClick={() => handleFileDownload("job_report")}
            />
          </div>
        );

      case "QUOTATION_REJECTED":
        return (
          <div className="job-action-buttons">
            <ActionButton
              icon="fa-download"
              label={`${WORK_ORDER} Report`}
              onClick={() => handleFileDownload("job_report")}
            />
            <ActionButton
              color="secondary"
              icon="fa-close"
              label={`Cancel ${WORK_ORDER}`}
              onClick={() => handleConfirmationAlerts("cancel_job")}
            />
          </div>
        );

      case "CANCELLED":
        return (
          <div className="job-action-buttons">
            <ActionButton
              icon="fa-download"
              label={`${WORK_ORDER} Report`}
              onClick={() => handleFileDownload("job_report")}
            />
          </div>
        );

      case "PART_REQUESTS":
        return (
          <div className="job-action-buttons">
            <ActionButton
              icon="fa-download"
              label={`${WORK_ORDER} Report`}
              onClick={() => handleFileDownload("job_report")}
            />
          </div>
        );

      case "REPAIR":
        return (
          <div className="job-action-buttons">
            <ActionButton
              icon="fa-download"
              label={`${WORK_ORDER} Report`}
              onClick={() => handleFileDownload("job_report")}
            />
          </div>
        );

      case "REPAIRED":
        return (
          <div className="job-action-buttons">
            <ActionButton
              icon="fa-download"
              label={`${WORK_ORDER} Report`}
              onClick={() => handleFileDownload("job_report")}
            />
            <ActionButton
              icon="fa-clipboard-check"
              label="Review Work Done"
              onClick={() => handleConfirmationAlerts("review_work_done")}
            />
          </div>
        );

      case "INVOICE_NOT_PAID":
        return (
          <div className="job-action-buttons">
            <ActionButton
              icon="fa-download"
              label={`${WORK_ORDER} Report`}
              onClick={() => handleFileDownload("job_report")}
            />
          </div>
        );

      case "INVOICE_PAID":
        return (
          <div className="job-action-buttons">
            <ActionButton
              icon="fa-download"
              label={`${WORK_ORDER} Report`}
              onClick={() => handleFileDownload("job_report")}
            />
          </div>
        );

      case "COMPLETED":
        return (
          <div className="job-action-buttons">
            <ActionButton
              icon="fa-download"
              label={`${WORK_ORDER} Report`}
              onClick={() => handleFileDownload("job_report")}
            />
          </div>
        );

      default:
        return <></>;
    }
  };

  // used to render quotation screen actions based on job status
  const renderQuotationActionBtns = () => {
    const status = jobFormData?.jobStatus;

    const hideActions =
      !Array.isArray(quotationSummary?.quotData) ||
      quotationSummary.quotData.length === 0;

    if (hideActions) return null;

    switch (status) {
      case "REQUEST_APPROVAL":
        return (
          <div className="job-action-buttons">
            <ActionButton
              color="danger"
              icon="fa-times"
              label={`Reject Quotaion`}
              onClick={() => handleConfirmationAlerts("reject_quotation")}
            />

            <ActionButton
              icon="fa-check"
              label={`Accept Quotaion`}
              onClick={() => handleConfirmationAlerts("accept_quotation")}
            />

            <ActionButton
              icon="fa-eye"
              tooltip="View Quotation"
              onClick={() => handleFileDownload("viewQuot", quotationId)}
              circle
            />

            <ActionButton
              icon="fa-download"
              tooltip="Download Quotation"
              onClick={() => handleFileDownload("quotation", quotationId)}
              circle
            />
          </div>
        );

      case "JOB_ALLOCATED":
      case "QUOTATION_IN_PROGRESS":
      case "QUOTATION_ACCEPTED":
      case "QUOTATION_REJECTED":
      case "CANCELLED":
      case "PART_REQUESTS":
      case "REPAIR":
      case "REPAIRED":
      case "INVOICE_NOT_PAID":
      case "INVOICE_PAID":
        return (
          <div className="job-action-buttons">
            <ActionButton
              icon="fa-eye"
              tooltip="View Quotation"
              onClick={() => handleFileDownload("viewQuot", quotationId)}
              circle
            />

            <ActionButton
              icon="fa-download"
              tooltip="Download Quotation"
              onClick={() => handleFileDownload("quotation", quotationId)}
              circle
            />
          </div>
        );

      default:
        return null;
    }
  };

  const handleDownloadMedia = async (mediaID, techinicalReportID) => {
    setIsDownloading(true);
    try {
      const res = await downloadJobMedia(mediaID, techinicalReportID);
      if (res.status === 200 && res.data) {
        const fileName =
          res.headers["content-disposition"]?.match(/filename="(.+?)"/)?.[1];
        const url = URL.createObjectURL(res.data);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(url);
      } else if (res.code === 404) {
        notify("danger", res?.message || "Media not found.");
      } else {
        notify(
          "danger",
          res?.message || "Failed to download media. Please try again.",
        );
      }
    } catch (error) {
      notify(
        "danger",
        error?.message || "Failed to download media. Please try again.",
      );
    }
    setIsDownloading(false);
  };

  const hasImage = !!jobFormData?.customerEquipment?.equipmentImage;

  const jobStatus = JOB_STATUS_OPTIONS.find(
    (item) => item.value === jobFormData.jobStatus
  );

  return (
    <>
      {isDownloading && (
        <div className="loading-overlay">
          <div className="loading-card">
            <i className="fa fa-spinner fa-spin fa-2x text-deep-blue mb-3" />
            <div className="font-weight-bold text-dark">
              Downloading… Please wait.
            </div>
          </div>
        </div>
      )}
      {isAPiProcessing && (
        <div className="loading-overlay">
          <div className="loading-card">
            <i className="fa fa-spinner fa-spin fa-2x text-deep-blue mb-3" />
            <div className="font-weight-bold text-dark">
              Processing… Please wait.
            </div>
          </div>
        </div>
      )}

      <Container fluid className="mt-4">
        <div className="rna-container">
          <NotificationAlert ref={notificationAlertRef} />
        </div>
        {showAlternative.loader ? (
          <div className="loader-job-details">
            <i className="fa fa-spinner fa-spin fa-2xl loader" />
          </div>
        ) : showAlternative.error &&
          showAlternative.error !== "Not Found" ? (
          <div className="loaderContainer text-muted d-flex flex-column">
            <h4 className="text-muted">
              No {SMALL_CASE_WORK_ORDER} details Available
            </h4>
          </div>
        ) :
          <>
            <div className={`customer-card mb-3`}>
              <Row className="align-items-center">
                <Col md="10" sm="8" xs="12">
                  <Breadcrumbs
                    items={[
                      { name: `${WORK_ORDER}`, link: "/customer/jobs" },
                      { name: `${jobFormData.customerLocation.outletName}` },
                    ]}
                  />
                </Col>

                <Col md="2" sm="4" xs="12">
                  <div className="job-id info-row">
                    <i className="fa fa-hashtag text-deep-blue mr-1" />
                    {WORK_ORDER} No:{" "}
                    <span className={`text-deep-blue`}>{decodedId || "NA"}</span>
                  </div>
                </Col>
              </Row>

              <Row className="info-row">
                <Col md="6" sm="12" className="mt-2">
                  <i className="fa fa-location-dot text-deep-blue mr-1" />
                  <span>{jobFormData.customerLocation.address || "-"}</span>
                </Col>
                <Col md="4" sm="6" className="mt-2">
                  <i className="fa fa-envelope text-deep-blue mr-1" />
                  <span>{jobFormData.customerLocation.contactEmail || "-"}</span>
                  {/* jobFormData.customer.email */}
                </Col>
                <Col md="2" sm="6" className="mt-2">
                  <i className="fa fa-phone text-deep-blue mr-1" />
                  <span>
                    +966 {jobFormData.customerLocation.contactPersonPhone || "-"}
                  </span>
                  {/* jobFormData.customer.phone  */}
                </Col>
              </Row>
            </div>

            <Row>
              <div className="m-3 border-0">
                <Row>
                  <Col md="6">
                    <Card className="border-0 mb-4 px-4 py-3 custom-card">
                      <Row className="align-items-center mb-3">
                        <Col className="job-action-btn">
                          <h4 className="text-deep-blue mb-0">
                            {WORK_ORDER} Information
                          </h4>
                          {renderJobInfoActionBtns()}
                        </Col>
                      </Row>

                      <div className="border-bottom border-muted mb-3" />
                      <Row>
                        <Col md="4" className="mb-3">
                          <FormGroup className="d-flex flex-column align-items-start">
                            <Label>{WORK_ORDER} Status</Label>
                            <span className="small-text font-weight-bold text-deep-blue text-wrap">
                              <Badge
                                pill
                                className="badge-lg"
                                style={getJobStatusStyle(jobFormData.jobStatus)}
                              >
                                {jobStatus?.label || jobFormData.jobStatus}
                              </Badge>
                            </span>
                          </FormGroup>
                        </Col>
                        <Col md="4" className="mb-3">
                          <FormGroup className="d-flex flex-column align-items-start">
                            <Label>{WORK_ORDER} Type</Label>
                            <span className="small-text text-wrap">
                              {jobFormData.jobTypeID?.label || "-"}
                            </span>
                          </FormGroup>
                        </Col>
                        <Col md="4" className="mb-3">
                          <FormGroup className="d-flex flex-column align-items-start">
                            <Label>{WORK_ORDER} Warranty</Label>
                            <span className="small-text text-wrap">
                              {jobFormData.underWarranty || "-"}
                            </span>
                          </FormGroup>
                        </Col>
                        <Col md="4" className="mb-3">
                          <FormGroup className="d-flex flex-column align-items-start">
                            <Label>Assigned Technician</Label>
                            <span className="small-text text-wrap">
                              {jobFormData?.technician?.label || "-"}
                            </span>
                          </FormGroup>
                        </Col>
                        <Col md="4" className="mb-3">
                          <FormGroup className="d-flex flex-column align-items-start">
                            <Label>Reported Issue</Label>
                            <span className="small-text text-wrap">
                              {jobFormData.clientNote || "-"}
                            </span>
                          </FormGroup>
                        </Col>
                        <Col md="4" className="mb-3">
                          <FormGroup className="d-flex flex-column align-items-start">
                            <Label>{WORK_ORDER} Priority</Label>
                            <span className="small-text text-wrap">
                              {jobFormData.priority || "-"}
                            </span>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Col md="12">
                        <Row className="align-items-center">
                          <Label>Uploaded Media</Label>
                        </Row>

                        {/* <div className="border-bottom border-muted mb-3" /> */}

                        <Row>
                          {jobMediaData?.jobMediaByClient?.length > 0 ? (
                            <div className="media-grid">
                              {jobMediaData?.jobMediaByClient?.map((img) => {
                                const src = img?.imageOrVIDeoPath;
                                const isPdf =
                                  typeof src === "string" &&
                                  src.toLowerCase().endsWith(".pdf");
                                const isVideo =
                                  typeof src === "string" &&
                                  [".mp4", ".mov", ".m4v", ".avi", ".mkv"].some((ext) =>
                                    src.toLowerCase().endsWith(ext),
                                  );
                                return (
                                  <div
                                    key={img.ID}
                                    className="media-card"
                                    onClick={() =>
                                      isVideo
                                        ? setSelectedVideo(src)
                                        : isPdf
                                          ? setSelectedPDF(src)
                                          : setSelectedImage(src)
                                    }
                                  >
                                    <div className="media-preview-wrapper">
                                      {isVideo ? (
                                        <video
                                          src={src}
                                          className="media-preview"
                                          muted
                                          controls
                                        />
                                      ) : isPdf ? (
                                        <iframe
                                          src={src}
                                          // title={img.title}
                                          className="pdf-preview"
                                        ></iframe>
                                      ) : (
                                        <img
                                          src={src}
                                          alt="product"
                                          className="media-preview"
                                        />
                                      )}
                                    </div>
                                    <div className="media-info">
                                      {/* <div className="media-title text-truncate">
                                                      Product Image {img.ID}
                                                    </div> */}
                                      <div className="uploaded-date">
                                        <div className="date-row">
                                          <i className="fa fa-calendar-alt date-icon" />
                                          <span className="uploaded-label">
                                            Uploaded Date:
                                          </span>
                                          <span className="date-line">
                                            {img?.createdAt
                                              ?.split(/\d{2}:\d{2}\s(?:AM|PM)/)[0]
                                              ?.trim()}
                                          </span>
                                        </div>

                                        <div className="time-line">
                                          {
                                            img?.createdAt?.match(
                                              /\d{2}:\d{2}\s(?:AM|PM)/,
                                            )?.[0]
                                          }
                                        </div>
                                      </div>
                                      <div
                                        className="media-actions"
                                        onClick={(e) => e.stopPropagation()}
                                      >
                                        <span
                                          className="link-action view-link"
                                          onClick={() =>
                                            isVideo
                                              ? setSelectedVideo(src)
                                              : isPdf
                                                ? setSelectedPDF(src)
                                                : setSelectedImage(src)
                                          }
                                        >
                                          <i className="fa fa-eye mr-1" /> View
                                        </span>
                                        <span
                                          className="link-action download-link"
                                          onClick={() =>
                                            handleDownloadMedia(
                                              img?.ID,
                                              img?.technicalReportID || 0,
                                            )
                                          }
                                        >
                                          <i className="fa fa-download mr-1" /> Download
                                        </span>

                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          ) : (
                            <span className="small-text text-wrap pb-4">
                              No media uploaded
                            </span>
                          )}
                        </Row>
                      </Col>


                      {/* <Row className="mb-4 d-flex flex-wrap align-items-center justify-content-end">
                        <Col className="d-flex flex-wrap" md="auto">
                          {renderJobInfoActionBtns()}
                        </Col>
                      </Row> */}
                    </Card>

                    <Card className="border-0 mb-4 px-4 py-3 custom-card">
                      <h4 className="mb-3 text-deep-blue">
                        Outlet Information
                      </h4>
                      <div className="border-bottom border-muted mb-3" />
                      <Row>
                        <Col md="4" className="mb-3">
                          <FormGroup className="d-flex flex-column align-items-start">
                            <Label>Outlet Name</Label>
                            <span className="small-text text-wrap">
                              {jobFormData.customerLocation.outletName ||
                                "-"}
                            </span>
                          </FormGroup>
                        </Col>
                        <Col md="4" className="mb-3">
                          <FormGroup className="d-flex flex-column align-items-start">
                            <Label>Address</Label>
                            <span className="small-text text-wrap">
                              {jobFormData.customerLocation.address ||
                                "-"}
                            </span>
                          </FormGroup>
                        </Col>
                        <Col md="4" className="mb-3">
                          <FormGroup className="d-flex flex-column align-items-start">
                            <Label>Region</Label>
                            <span className="small-text text-wrap">
                              {jobFormData.customerLocation.regionName ||
                                "-"}
                            </span>
                          </FormGroup>
                        </Col>
                        <Col md="4" className="mb-3">
                          <FormGroup className="d-flex flex-column align-items-start">
                            <Label>Contact Person</Label>
                            <span className="small-text text-wrap">
                              {jobFormData.customerLocation
                                .contactPersonName || "-"}
                            </span>
                          </FormGroup>
                        </Col>
                        <Col md="4" className="mb-3">
                          <FormGroup className="d-flex flex-column align-items-start">
                            <Label>Email Address</Label>
                            <span className="small-text text-wrap">
                              {jobFormData.customerLocation
                                .contactEmail || "-"}
                            </span>
                          </FormGroup>
                        </Col>
                        <Col md="4" className="mb-3">
                          <FormGroup className="d-flex flex-column align-items-start">
                            <Label>Contact Number</Label>
                            <span className="small-text text-wrap">
                              {jobFormData.customerLocation
                                .contactPersonPhone || "-"}
                            </span>
                          </FormGroup>
                        </Col>
                        {jobFormData.customerLocation
                          .alternateContactPersonName !== "" ? (
                          <Col md="4" className="mb-3">
                            <FormGroup className="d-flex flex-column align-items-start">
                              <Label>Alternate Contact Person</Label>
                              <span className="small-text text-wrap">
                                {jobFormData.customerLocation
                                  .alternateContactPersonName || "-"}
                              </span>
                            </FormGroup>
                          </Col>
                        ) : (
                          ""
                        )}
                        {jobFormData.customerLocation
                          .alternateContactEmail !== "" ? (
                          <Col md="4" className="mb-3">
                            <FormGroup className="d-flex flex-column align-items-start">
                              <Label>Alternate Email Address</Label>
                              <span className="small-text text-wrap">
                                {jobFormData.customerLocation
                                  ?.alternateContactEmail || "-"}
                              </span>
                            </FormGroup>
                          </Col>
                        ) : (
                          ""
                        )}
                        {jobFormData.customerLocation
                          .alternateContactPersonPhone !== "" ? (
                          <Col md="4" className="mb-3">
                            <FormGroup className="d-flex flex-column align-items-start">
                              <Label>Alternate Contact Number</Label>
                              <span className="small-text text-wrap">
                                {jobFormData.customerLocation
                                  ?.alternateContactPersonPhone || "-"}
                              </span>
                            </FormGroup>
                          </Col>
                        ) : (
                          ""
                        )}

                        <Col md="12" className="d-flex justify-content-center align-items-center mt-2 mb-3">
                          {!isLoaded ? (
                            <div className="text-center py-5">
                              <div
                                className="spinner-border text-deep-blue"
                                role="status"
                              />
                              <div className="mt-2">Loading map...</div>
                            </div>
                          ) : mapError ? (
                            <div className="alert alert-warning text-center w-100">
                              <strong>Unable to load map</strong>
                              <br />
                              {mapError}
                            </div>
                          ) : (
                            <GoogleMap
                              mapContainerClassName="map-container"
                              zoom={markerPosition ? 15 : 4}
                              center={markerPosition || defaultCenter}
                              onLoad={(mapInstance) => setMap(mapInstance)}
                              options={{
                                streetViewControl: false,
                                fullscreenControl: false,
                              }}
                              onUnmount={() => setMap(null)}
                            >
                              {markerPosition && (
                                <Marker position={markerPosition} />
                              )}
                            </GoogleMap>
                          )}
                        </Col>
                      </Row>
                    </Card>

                    <Card className="mb-4 px-4 py-3 custom-card custom-height-box">
                      <Row className="align-items-center mb-3">
                        <Col className="d-flex justify-content-between align-items-center">
                          <h4 className="text-deep-blue mb-0">
                            Quotation
                          </h4>

                          {renderQuotationActionBtns()}
                        </Col>
                      </Row>
                      <div className="border-bottom border-muted mb-3" />
                      <Row className="custom-timeline">
                        <Col className="mb-3">
                          {quotationListState.loader ? (
                            <div className="text-center text-muted py-4">
                              <i className="fa fa-spinner fa-spin fa-2x text-muted" />
                            </div>
                          ) : quotationListState.error ? (
                            <div className="text-center text-muted py-4">
                              {quotationListState.error}
                            </div>
                          ) : quotationListState?.noRecords ? (
                            <div className="text-center text-muted py-4">
                              No quotation available
                            </div>
                          ) : <>
                            <div className="quotation-container">
                              <div className="job-quotation-table-wrapper ">
                                <Table className="job-quotation-table">
                                  <thead>
                                    <tr>
                                      <th>Item</th>
                                      <th className="text-center">Qty</th>
                                      <th className="text-right">Unit Price</th>
                                      {/* <th className="text-center">Discount</th>
                              <th className="text-right">Total</th> */}
                                    </tr>
                                  </thead>

                                  <tbody>
                                    {quotationSummary?.quotData?.length > 0 ? (
                                      quotationSummary.quotData.map((item, index) => (
                                        <tr key={index}>
                                          <td className="description-cell">
                                            <div className="item-title">
                                              {item.itemType === "SERVICE" ? "Service" : item.itemNumber}
                                            </div>

                                            <div className="item-description">
                                              {item.description || "-"}
                                            </div>
                                          </td>

                                          <td className="text-center qty">
                                            {item.quantity || 0}
                                          </td>

                                          <td className="text-right">
                                            SAR {formatSAR(item.unitPrice)}
                                          </td>

                                          {/* <td className="text-center">
                                    <span
                                      className={`discount-badge ${item.discount > 0 ? "active" : ""
                                        }`}
                                    >
                                      {item.discount ? `${item.discount}%` : "0%"}
                                    </span>
                                  </td>

                                  <td className="text-right total">
                                    SAR {formatSAR(item.totalPrice)}
                                  </td> */}
                                        </tr>
                                      ))
                                    ) : (
                                      <tr>
                                        <td colSpan={5} className="empty-state">
                                          No quotation available
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </Table>
                              </div>
                            </div>
                          </>
                          }
                        </Col>
                      </Row>
                      <Row>
                        <Col className="mb-3">
                          {!quotationListState.loader && !quotationListState.error && !quotationListState?.noRecords &&
                            <div className="quotation-summary-card">

                              {showDetails && (
                                <div className="summary-details">

                                  <div className="summary-row">
                                    <span>Spare Parts Charges</span>
                                    <span>
                                      SAR {formatSAR(quotationSummary?.sparePartTotal || 0)}
                                    </span>
                                  </div>

                                  <div className="summary-row">
                                    <span>Service Charges</span>
                                    <span>
                                      SAR {formatSAR(quotationSummary?.serviceTotal || 0)}
                                    </span>
                                  </div>

                                  <div className="summary-row">
                                    <span>Subtotal</span>
                                    <span>
                                      SAR {formatSAR(quotationSummary?.subtotal || 0)}
                                    </span>
                                  </div>

                                  <div className="summary-row discount">
                                    <span>
                                      Discount ({(quotationSummary?.discountPercentage || 0).toFixed(2)}%)
                                    </span>

                                    <span>
                                      SAR {formatSAR(quotationSummary?.discount || 0)}
                                    </span>
                                  </div>

                                  <div className="summary-row">
                                    <span>Discounted Total</span>
                                    <span>
                                      SAR {formatSAR(quotationSummary?.discountedTotal || 0)}
                                    </span>
                                  </div>

                                  <div className="summary-row">
                                    <span>VAT (15%)</span>
                                    <span>
                                      SAR {formatSAR(quotationSummary?.vatAmount || 0)}
                                    </span>
                                  </div>

                                </div>
                              )}

                              <div className={`summary-row grand ${showDetails ? "pt-2" : "p-0"}`}>
                                <span className="bold-label">Grand Total</span>

                                <div className="summary-right">
                                  <strong className="amount">
                                    SAR {formatSAR(quotationSummary?.grandTotal || 0)}
                                  </strong>

                                  <button
                                    type="button"
                                    className="expand-btn"
                                    onClick={() => setShowDetails((prev) => !prev)}
                                  >
                                    <i
                                      className={`fa fa-chevron-${showDetails ? "down" : "up"}`}
                                    />
                                  </button>
                                </div>
                              </div>

                              {quotationSummary?.clientPaymentType === "CASH" &&
                                quotationSummary?.paidAmount && <div className="summary-row paid">
                                  <span className="bold-label">Paid Amount</span>

                                  <div className="summary-right">
                                    <strong className="amount">
                                      SAR {formatSAR(quotationSummary?.paidAmount || 0)}
                                    </strong>

                                    {/* Placeholder to keep alignment */}
                                    <div className="expand-placeholder" />
                                  </div>
                                </div>}
                            </div>
                          }
                        </Col>
                      </Row>
                    </Card>

                    <Card className="mb-4 px-4 py-3 custom-card custom-height-box">
                      <Row className="align-items-center mb-3">
                        <Col>
                          <h4 className="text-deep-blue mb-0">
                            Manuals & Documents
                          </h4>
                        </Col>
                      </Row>
                      <div className="border-bottom border-muted mb-3" />
                      <Row className="custom-timeline">
                        {equipmentData?.data?.productDocuments?.length > 0 ? (
                          equipmentData.data.productDocuments.map((item) => (
                            <Col key={item.id} className="mb-3">
                              <div className="hover-lift rounded p-3 d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center file-info">
                                  <div className="doc-icon-box">
                                    <i className="fa fa-file"></i>
                                  </div>

                                  <div className="ms-3 file-details">
                                    <span className="small text-muted d-block mb-1">
                                      File Name
                                    </span>

                                    <span className="small-text">
                                      {item.document_title || "-"}
                                    </span>
                                  </div>
                                </div>

                                <div
                                  className="download-btn pointer"
                                  onClick={() => handleFileDownload("equipment_manual", item.id)}
                                >
                                  <i className="fa fa-download mr-1" />
                                  Download
                                </div>
                              </div>
                            </Col>
                          ))
                        ) : (
                          <Col>
                            <div className="text-center text-muted py-4">
                              No records available
                            </div>
                          </Col>
                        )}
                      </Row>
                    </Card>

                    <Card className="mb-4 px-4 py-3 custom-card custom-height-box">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h4 className="text-deep-blue mb-0">Equipment Service History</h4>
                      </div>

                      <div className="border-bottom mb-3" />
                      <div className="custom-timeline">
                        {serviveHistoryData?.data?.job?.length > 0 ? (
                          serviveHistoryData.data.job.map((item) => (
                            <div key={item.ID} className="service-item mb-3">
                              <div className="d-flex justify-content-between align-items-start">
                                <div className="service-id">
                                  {WORK_ORDER} No: {item.ID}
                                </div>

                                <div className="service-date">
                                  {item.createdAt}
                                </div>
                              </div>

                              <div className="service-type mt-2">
                                {item.jobTypeID?.name || "-"}
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="text-center text-muted py-4">
                            No service history available
                          </div>
                        )}
                      </div>
                    </Card>
                  </Col>

                  <Col md="6">
                    <Card className="border-0 mb-4 px-4 py-3 custom-card schedule-box">
                      <h4 className="mb-3 text-deep-blue">
                        Schedule Date & Time
                      </h4>
                      <div className="">
                        <div className="border-bottom border-muted mb-3" />
                        {jobFormData?.jobSchedules?.map(
                          (item, index) => (
                            <div key={index} className="mb-3">
                              <h5 className="text-deep-blue mb-2">
                                Day {index + 1}:
                              </h5>
                              <Row className="d-flex align-items-start mb-0 p-0">
                                <Col md="6">
                                  <FormGroup className="d-flex flex-column align-items-start">
                                    <Label>Start</Label>
                                    <span className="small-text">
                                      {item.scheduledFrom || "-"}
                                    </span>
                                  </FormGroup>
                                </Col>
                                <Col md="6">
                                  <FormGroup className="d-flex flex-column align-items-start">
                                    <Label>End</Label>
                                    <span className="small-text">
                                      {item.scheduledTo || "-"}
                                    </span>
                                  </FormGroup>
                                </Col>
                              </Row>
                            </div>
                          ),
                        )}
                      </div>
                    </Card>

                    <Card className="border-0 mb-4 px-4 py-3 custom-card">
                      <h4 className="mb-3 text-deep-blue">
                        Equipment Details
                      </h4>
                      <div className="border-bottom border-muted mb-3" />

                      <Row>
                        {/* Details */}
                        <Col md={hasImage ? "8" : "12"}>
                          <Row>
                            <Col md={hasImage ? "6" : "4"} className="mb-3">
                              <FormGroup>
                                <Label>Equipment Name</Label>
                                <div className="small-text">
                                  {jobFormData.product.label || "-"}
                                </div>
                              </FormGroup>
                            </Col>

                            <Col md={hasImage ? "6" : "4"} className="mb-3">
                              <FormGroup>
                                <Label>Manufacturer</Label>
                                <div className="small-text">
                                  {jobFormData.manufacturer.label || "-"}
                                </div>
                              </FormGroup>
                            </Col>


                            <Col md={hasImage ? "6" : "4"} className="mb-3">
                              <FormGroup>
                                <Label>Model</Label>
                                <div className="small-text">
                                  {jobFormData.product.modelNo || "-"}
                                </div>
                              </FormGroup>
                            </Col>

                            <Col md={hasImage ? "6" : "4"} className="mb-3">
                              <FormGroup>
                                <Label>Serial No.</Label>
                                <div className="small-text">
                                  {jobFormData.customerEquipment.serialNo || "-"}
                                </div>
                              </FormGroup>
                            </Col>

                            <Col md={hasImage ? "6" : "4"} className="mb-3">
                              <FormGroup>
                                <Label>Purchase Date</Label>
                                <div className="small-text">
                                  {jobFormData.purchaseDate || "-"}
                                </div>
                              </FormGroup>
                            </Col>

                            <Col md={hasImage ? "6" : "4"} className="mb-3">
                              <FormGroup>
                                <Label>Purchase Invoice</Label>
                                <div className="small-text">
                                  {jobFormData.customerEquipment.invoicePath ? (
                                    <span
                                      className="text-info pointer"
                                      onClick={() =>
                                        handleFileDownload(
                                          "invoice",
                                          jobFormData?.customerEquipment?.value
                                        )
                                      }
                                    >
                                      Download
                                    </span>
                                  ) : (
                                    "-"
                                  )}
                                </div>
                              </FormGroup>
                            </Col>
                          </Row>
                        </Col>

                        {/* Image */}
                        {hasImage && (
                          <Col md="4" className="d-flex justify-content-center">
                            <div className="media-preview-wrapper">
                              <img
                                src={jobFormData.customerEquipment.equipmentImage}
                                alt="Equipment"
                                className="img-fluid rounded border img-style"
                              />
                            </div>
                          </Col>
                        )}
                      </Row>
                    </Card>

                    <Card className="mb-4 px-4 py-3 custom-card">
                      <Row className="align-items-center mb-3">
                        <Col>
                          <h4 className="text-deep-blue mb-0">
                            Technical Report
                          </h4>
                        </Col>
                      </Row>

                      <div className="border-bottom border-muted mb-3" />
                      {showAlternative.techRepoLoader ? (
                        <div className="loaderContainer">
                          <i className="fa fa-spinner fa-spin fa-2xl loader" />
                        </div>
                      ) : showAlternative.techRepoError &&
                        showAlternative.techRepoError !== "Not Found" ? (
                        <div className="loaderContainer text-muted d-flex flex-column">
                          <h4 className="text-muted">
                            No technical report available
                          </h4>
                        </div>
                      ) : (
                        <Row>
                          <Col md="6" className="mb-3">
                            <FormGroup className="d-flex flex-column align-items-start">
                              <Label>Serial No</Label>
                              <span className="small-text text-wrap">
                                {techRepoFormData?.serialNo?.value || "-"}
                              </span>
                            </FormGroup>
                          </Col>
                          <Col md="6" className="mb-3">
                            <FormGroup className="d-flex flex-column align-items-start">
                              <Label>Findings</Label>
                              <span className="small-text text-wrap">
                                {techRepoFormData?.otherFinding?.value || "-"}
                              </span>
                            </FormGroup>
                          </Col>
                          <Col md="6" className="mb-3">
                            <FormGroup className="d-flex flex-column align-items-start">
                              <Label>Cause of Failure</Label>
                              <span className="small-text text-wrap">
                                {techRepoFormData?.causeOfFailure?.value ||
                                  "-"}
                              </span>
                            </FormGroup>
                          </Col>
                          <Col md="6" className="mb-3">
                            <FormGroup className="d-flex flex-column align-items-start">
                              <Label>Other Actions</Label>
                              <span className="small-text text-wrap">
                                {techRepoFormData?.additionalInfo?.value ||
                                  "-"}
                              </span>
                            </FormGroup>
                          </Col>
                          <Col md="12">
                            <Row className="align-items-center mb-2">
                              <Col>
                                <Label>Attachments</Label>
                              </Col>
                            </Row>

                            {/* <div className="border-bottom border-muted mb-3" /> */}

                            <Row>
                              <Col>
                                <div className="media-grid-repo  pb-2">
                                  {techRepoFormData?.media?.length === 0 ? "No attachments" : techRepoFormData.media.map((med) => {
                                    const src =
                                      med.mediaPath?.default || med.mediaPath;
                                    const isVideo =
                                      typeof src === "string" &&
                                      src
                                        .toLowerCase()
                                        .endsWith(
                                          ".mp4" || "mov" || "avi" || "mkv",
                                        );

                                    return (
                                      <div
                                        key={med.ID}
                                        className="media-card"
                                        onClick={() => setSelectedImage(src)}
                                      >
                                        <div className="media-preview-wrapper">
                                          {isVideo ? (
                                            <div className="video-preview-wrapper position-relative">
                                              <video
                                                src={src}
                                                className="media-preview"
                                              // muted
                                              // controls
                                              />
                                              <span className="video-play-btn position-absolute">
                                                <i className="fa fa-play" />
                                              </span>
                                            </div>
                                          ) : (
                                            <img
                                              src={src}
                                              alt="product"
                                              className="media-preview"
                                            />
                                          )}
                                        </div>

                                        {/* <div className="media-info">
                                          <div className="media-title text-truncate">
                                            Product Image {med.ID}
                                          </div>

                                          <div
                                            className="media-actions"
                                            onClick={(e) =>
                                              e.stopPropagation()
                                            }
                                          >
                                            <span
                                              className="link-action view-link"
                                              onClick={() =>
                                                setSelectedImage(src)
                                              }
                                            >
                                              <i className="fa fa-eye mr-1" />
                                            </span>

                                            <span
                                              className="link-action download-link"
                                              onClick={() => {
                                                const a =
                                                  document.createElement("a");
                                                a.href = src;
                                                a.target = "_blank";
                                                a.download = `product-media-${med.ID}`;
                                                a.click();
                                              }}
                                            >
                                              <i className="fa fa-download mr-1" />
                                            </span>
                                          </div>
                                        </div> */}
                                      </div>
                                    );
                                  })}
                                </div>
                              </Col>
                            </Row>
                            {/* </Card> */}
                          </Col>
                        </Row>
                      )}
                    </Card>

                    <Card className="mb-0 px-4 py-3 custom-card timeline-box">
                      <h4 className="mb-3 text-deep-blue">Timeline</h4>
                      <div className="border-bottom border-muted mb-0" />
                      <Card className="custom-timeline card-timeline card-plain mb-0">
                        {showAlternative.timeLineLoader ? (
                          <div className="loaderContainer">
                            <i className="fa fa-spinner fa-spin fa-2xl loader" />
                          </div>
                        ) : showAlternative.timeLineError ||
                          timeline.length === 0 ? (
                          <div className="loaderContainer text-muted d-flex flex-column">
                            <h4 className="text-muted">
                              No time line Available
                            </h4>
                          </div>
                        ) : (
                          <CardBody className="scrollbar-inner overflow-auto">
                            <div className="timeline-container">
                              <div className="timeline-line" />
                              {timeline.map((item, index) => (
                                <div className="timeline-item" key={index}>
                                  <div className="timeline-dot" />
                                  <div className="timeline-card">
                                    <div className="d-flex align-items-center justify-content-between">
                                      <div className="name">{item.event}</div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                      <div className="status text-muted">{item.date}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </CardBody>
                        )}
                      </Card>
                    </Card>
                  </Col>
                </Row>

              </div>
              <CustomModal
                isOpen={!!selectedImage}
                onClose={() => setSelectedImage(null)}
                title="Image Preview"
              >
                <div className="image-container">
                  <img
                    src={selectedImage}
                    alt="Full preview"
                    className="image-preview"
                  />
                </div>
              </CustomModal>
              <CustomModal
                isOpen={!!selectedPDF}
                onClose={() => setSelectedPDF(null)}
                title={"Document Preview"}
              >
                <div className="pdf-container">
                  <iframe
                    src={selectedPDF}
                    title="PDF Viewer"
                    className="pdf-iframe"
                  />
                </div>
              </CustomModal>
              <CustomModal
                isOpen={!!selectedVideo}
                onClose={() => setSelectedVideo(null)}
                title="Video Preview"
              >
                <div className="image-container">
                  <video
                    src={selectedVideo}
                    className="image-preview"
                    controls
                    muted
                  />
                </div>
              </CustomModal>
            </Row>
          </>}
      </Container>
    </>
  );
}

export default JobDetails;
